import { render, staticRenderFns } from "./SizeDialog.vue?vue&type=template&id=45747ff0"
import script from "./SizeDialog.vue?vue&type=script&lang=js"
export * from "./SizeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports